import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  accent?: "primary" | "accent" | "secondary";
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

const accentMap = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function SectionHeading({
  title,
  subtitle,
  accent = "primary",
  moreTo,
  moreLabel = "查看更多",
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className={`w-1.5 h-6 md:h-7 rounded-full ${accentMap[accent]}`}></span>
        <div className="min-w-0">
          <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
            {icon && <i className={`${icon} text-primary-600`}></i>}
            <span className="truncate">{title}</span>
          </h2>
          {subtitle && (
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}